import { useCallback } from 'react';

import { segmentTrack } from '@/hooks/analytics/useTracking';

import BuildStatus from '../../../models/BuildStatus';

const getBuildStatusText = (
  buildStatus: BuildStatus,
): 'running' | 'successful' | 'failed' | 'aborted' | 'aborted with success' | '' => {
  switch (buildStatus) {
    case BuildStatus.Running:
      return 'running';
    case BuildStatus.Success:
      return 'successful';
    case BuildStatus.Error:
      return 'failed';
    case BuildStatus.Aborted:
      return 'aborted';
    case BuildStatus.AbortedWithSuccess:
      return 'aborted with success';
    default:
      return '';
  }
};

export const useTrackBuildDetailsTabChange = (
  buildSlug: string,
  buildStatus: BuildStatus,
  canSpeedUp: boolean,
  projectId: string,
) => {
  return useCallback(
    (tabId: string, isDefaultTab = false) =>
      segmentTrack('Build Details Tab Displayed', {
        event_schema_version: 2.0,
        build_slug: buildSlug,
        build_status: getBuildStatusText(buildStatus),
        tab_name: tabId,
        is_default_tab: isDefaultTab,
        page_load_id: '/build/_',
        project_id: projectId,
        is_speed_up_build_with_caching_notification_card_displayed: canSpeedUp,
      }),
    [buildSlug, buildStatus, canSpeedUp, projectId],
  );
};
